import { render } from "./ResearchDetailPage.vue?vue&type=template&id=1a82ef32&scoped=true"
import script from "./ResearchDetailPage.vue?vue&type=script&lang=js"
export * from "./ResearchDetailPage.vue?vue&type=script&lang=js"

import "./ResearchDetailPage.vue?vue&type=style&index=0&id=1a82ef32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a82ef32"]])

export default __exports__